
export default {
  getUrlKey(key) {
    return decodeURIComponent((new RegExp('[?|&]' + key + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ""])[1].replace(/\+/g, '%20')) || null
  },
  // getUrlKey() {
  //   return new Proxy(new URLSearchParams(window.location.search), {
  //     get: (searchParams, prop) => searchParams.get(prop),
  //   });
  // }
  // url的参数FlutterType
  // 1是Flutter h5
  // 2是Flutter 安卓
  // 3是Flutter iOS
  // 4是其它 
  callWebviewMethod(name, val, valname) {
    let rn_flutter_obj = {}
    if(val) {
      rn_flutter_obj = {
        type: name,
        [valname]: val
      }
      if (window?.AndroidClient && window?.AndroidClient[name] || false) {
        window?.AndroidClient[name](val);
      }
    } else {
      rn_flutter_obj = {
        type: name
      }
      if (window?.AndroidClient && window?.AndroidClient[name] || false) {
        window?.AndroidClient[name]();
      }
    }

    if(this.getUrlKey('FlutterType')) {
      switch(this.getUrlKey('FlutterType')){
        case '1':
          window.parent.postMessage(JSON.stringify(rn_flutter_obj), '*');
          break;
        case '2':
        case '3':
          window.LivingMessage.postMessage(JSON.stringify(rn_flutter_obj));
          break;
          default:
            break;
      }
    }
    if (this.getUrlKey('isRn') == 1) {
      window.postMessage(JSON.stringify(rn_flutter_obj));
    }
  },
  getAppcategory(text) {
    let hash = window.location.hash;
    if (hash != '') {
      let arr = hash.split('&');
      let para = '';
      arr.map((el, index) => {
        if (el.match(text)) {
          para = arr[index].split('=')[1];
        }
      })
      return para;
    }
  },
  getQueryString(name) {
    let reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i');
    let r = window.location.search.substring(1).match(reg);
    if (r != null) {
      return decodeURIComponent(r[2]); // 解密
    }
    return null;
  },
  scriptInsert(url, sucess, failed) {
    return new Promise((resolve, reject) => {
      const script = document.createElement("script");
      script.type = "text/javascript";
      script.src = url;
      script.onload = () => {
        if (sucess) sucess();
        resolve(true);
      };
      script.onerror = (err) => {
        if (failed) failed();
        reject(err);
      };
      document.getElementsByTagName('head')[0].appendChild(script)
    })
  },
  isiOS() {
    return !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
  },
  // 用于处理上下拉动问题，指定区域可以滚动
  touchScroll(id) {
    var el = document.getElementById(id);
    var scrollStartPos = 0;

    el.addEventListener(
      "touchstart",
      function (event) {
        scrollStartPos = this.scrollTop + event.touches[0].pageY;

        event.stopPropagation;
        // event.preventDefault();
      },
      false
    );

    el.addEventListener(
      "touchmove",
      function (event) {
        this.scrollTop = scrollStartPos - event.touches[0].pageY;
        event.stopPropagation;
        // event.preventDefault();
      },
      false
    );
  }
}
